/*
 * Validación de quizzes en el cliente, igual que la del backend (LMS-091).
 * Cada función devuelve la clave i18n del primer error o null.
 */
export const QUESTION_TYPES = ['single', 'multiple']
export const MIN_OPTIONS = 2

// Una sola correcta en `single`; al menos una en `multiple`.
const correctOptionsRule = {
    single: (count) => count === 1 ? null : 'projects.quiz_single_requires_one_correct',
    multiple: (count) => count >= 1 ? null : 'projects.quiz_multiple_requires_correct',
}

export function validateQuestion(question) {
    if (!QUESTION_TYPES.includes(question.type)) return 'projects.quiz_question_type_required'
    if (!question.statement?.trim()) return 'projects.quiz_statement_required'
    if (question.options.length < MIN_OPTIONS) return 'projects.quiz_min_options'
    if (question.options.some((option) => !option.text?.trim())) return 'projects.quiz_option_text_required'

    return correctOptionsRule[question.type](question.options.filter((option) => option.is_correct).length)
}

export function validateSettings(quiz) {
    if (!quiz.title?.trim()) return 'projects.quiz_title_required'

    const passPercentage = quiz.pass_percentage
    if (!Number.isInteger(passPercentage) || passPercentage < 0 || passPercentage > 100) {
        return 'projects.quiz_pass_percentage_invalid'
    }

    // Vacío (null) significa intentos ilimitados.
    if (quiz.max_attempts !== null && (!Number.isInteger(quiz.max_attempts) || quiz.max_attempts < 1)) {
        return 'projects.quiz_max_attempts_invalid'
    }
    return null
}
